// ※サーバから返ってきている情報を使っている項目で、ページに反映されないデータもあるので注意
const imgPath = '/static/img/yearluck/y2023/'
const dirKey = 'hoshihitomi'

const info = {
  name: '星ひとみ',
  itemId: 6401,
  lpId: 0, //なければ0
  pkgTitle: '星ひとみの2022年のあなたの運勢あああああああああああああああ',
  price: 999,
  memberPrice: 500,
  pkgDescription: 'パッケージの説明文が入ります。パッケージの説明文が入ります。パッケージの説明文が入ります。パッケージの説明文が入ります。パッケージの説明文が入ります。パッケージの説明文が入ります。パッケージの説明文が入ります。',
  pkgNotice: '※この商品は、占いサイト『星ひとみ☆幸せの天星術』の「天星術で導き出す2023年上半期の詳細運勢」の一部と同じ内容のものになります。',
}

const top = {
  thumbnail: `${imgPath}top/counselor/${dirKey}/top_thumnail.png`,
  pkgTitleImg: `${imgPath}top/counselor/${dirKey}/top_pkg_title_img.png`,
  pkgBackImg: `${imgPath}top/counselor/${dirKey}/top_bg.png`,
}

const input = {
  thumbnail: `${imgPath}input/counselor/${dirKey}/input_thumnail.png`,
  fukiImage: `${imgPath}input/counselor/${dirKey}/input_fuki.png`,
  pkgBackImg: `${imgPath}input/counselor/${dirKey}/bg_topinfo.png`,
  headInfoBgUpp: `${imgPath}input/counselor/${dirKey}/bg_input_headinfo_upper.png`,
  headInfoBgMdl: `${imgPath}input/counselor/${dirKey}/bg_input_headinfo_middle.png`,
}

const result = {
  title: '天星術で導き出す<br>2023年上半期の詳細運勢',
  thumbnail: `${imgPath}result/counselor/${dirKey}/teller_icon.png`,
  underThumbnail: `${imgPath}result/counselor/${dirKey}/teller_icon.png`,
  description: '鑑定に来てくださり、ありがとうございます。12年に一度めぐってくる、2023年のあなたの運気をくわしく解説していきます。どんな運気の1年であれ、先に知っておけば良い選択をすることができますよ。',
  //bottomFukiMessage: '鑑定はいかがでしたか？　あなたの新しい1年が楽しく過ごせますように。<br>もう少し、あなたのことを占ってもいいですか？',
  bottomFukiMessage: '鑑定はいかがでしたか？　あなたの新しい1年が、明るく幸せに過ごせますように。',
}

export default {
  info,
  top,
  input,
  result,
}



// WEBPACK FOOTER //
// ./resources/assets/js/utvStore/components/YearLuck/y2023/data/counselor/pkg01_hoshi_hitomi.js